import { createSelector } from 'reselect'
import featureScopesSelector from './featureScopesSelector'

const isSwitchBuildabilityEnabledSelector = createSelector(
    featureScopesSelector,
    (featureScopes): boolean => featureScopes.includes('switchBuildability'),
)

export default isSwitchBuildabilityEnabledSelector
